import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../assets/styles/tokens";
import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearFilterMobileDataMap,
  resetMobileFilters,
} from "../../../../../../../features/trendsSlice";
import { removeTrendParams } from "../../helpers/funcs/filterURLRemove";
import {
  removeParamsFromList,
  timeUnitParams,
} from "../../helpers/funcs/timeUnitParams";
const TrendsDetails = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { loadingTrendsMobData } = useSelector((state: any) => state.trends);
  const dispatch = useDispatch();
  const dateType = searchParams.get("dateType") || "click_date";
  const value = dateType === "click_date" ? 1 : 0;
  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    const newType = newValue === 0 ? "action_date" : "click_date";
    setSearchParams((prev) => {
      let updated = removeTrendParams(prev);
      updated = removeParamsFromList(updated, timeUnitParams);
      updated.set("dateType", newType);
      return updated;
    });
    dispatch(resetMobileFilters());
    dispatch(clearFilterMobileDataMap());
  };
  const tabConfig = [
    { label: "Action Date", trackerId: "699" },
    { label: "Click Date", trackerId: "700" },
  ];
  return (
    <>
      <Typography
        sx={{
          fontSize: typography.Size.Text.md.$value,
          my: 1,
          fontWeight: typography.Font_weight.Medium.$value,
        }}
      >
        Trends Details
      </Typography>
      <Stack sx={{ my: 1 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          centered
          sx={{
            "& .MuiTabs-scrollButtons": {
              color: colors.GrayDarkMode[700].$value,
            },
            background: colors.GrayLightMode[100].$value,
            borderTop: "3px solid" + colors.GrayLightMode[100].$value,
            borderBottom: "3px solid" + colors.GrayLightMode[100].$value,
            borderRadius: spacing.Radius.md.$value,
            minHeight: spacing.Spacing["3xl"].$value,
          }}
          TabIndicatorProps={{
            sx: {
              height: spacing.Spacing.none.$value,
            },
          }}
        >
          {tabConfig.map((tab, index) => (
            <Tab
              key={tab.label}
              disabled={loadingTrendsMobData}
              label={tab.label}
              disableRipple
              {...(tab.trackerId && value === index
                ? { "data-tracker": tab.trackerId }
                : {})}
              sx={{
                width: "49.1%",
                color: colors.GrayDarkMode[500].$value,
                textTransform: "none",
                fontWeight: typography.Font_weight.Regular.$value,
                borderRadius: spacing.Radius.xs.$value,
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                padding: 0,
                minHeight: spacing.Spacing["3xl"].$value,
                "&.Mui-selected": {
                  color: colors.GrayDarkMode[900].$value,
                  fontWeight: typography.Font_weight.Bold.$value,
                  backgroundColor: colors.Base.White.$value + "!important",
                },
                "&:hover": { backgroundColor: "transparent" },
              }}
            />
          ))}
        </Tabs>
      </Stack>
    </>
  );
};

export default TrendsDetails;
